import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../Common/Layout";

export default function DeleteDeliveryorder() {

  
  const [search, setSearch] = useState("");

  const [orders, setOrders] = useState([]);
  const token = sessionStorage.getItem("token");

  /* ============================
      FETCH DELIVERY ORDERS
  ============================ */
  const fetchOrders = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/delete/delivery-orders",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setOrders(res.data.data || []);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to fetch delivery orders",
      });
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  
  /* ============================
        DELETE DELIVERY ORDER
  ============================ */

  const handleDelete = async (order) => {
    const result = await Swal.fire({
      title: "⚠ Delivery Order Details",
      width: "800px",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "🗑 Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",

      html: `
      <div style="text-align:left;font-size:14px;max-height:400px;overflow:auto">

        <table style="width:100%;border-collapse:collapse">

          <tr><td><b>DO No</b></td><td>${order.doNo}</td></tr>
          <tr><td><b>CDD No</b></td><td>${order.cddNo}</td></tr>
          <tr><td><b>Date</b></td><td>${order.date}</td></tr>
          <tr><td><b>Validity</b></td><td>${order.doValidityTill}</td></tr>

          <tr><td><b>Client</b></td><td>${order.clientName}</td></tr>
          <tr><td><b>Client Address</b></td><td>${order.clientAddress}</td></tr>
          <tr><td><b>Contact No</b></td><td>${order.contactNo}</td></tr>

          <tr><td><b>Main Importer</b></td><td>${order.mainImporter}</td></tr>
          <tr><td><b>Buyer</b></td><td>${order.buyer}</td></tr>
          <tr><td><b>Buyer Address</b></td><td>${order.buyerAddress}</td></tr>
          <tr><td><b>GST No</b></td><td>${order.gstNo}</td></tr>

          <tr><td><b>Commodity</b></td><td>${order.commodity}</td></tr>
          <tr><td><b>Variety</b></td><td>${order.variety}</td></tr>
          <tr><td><b>Quantity</b></td><td>${order.doQuantity}</td></tr>
          <tr><td><b>Packing</b></td><td>${order.packing}</td></tr>

          <tr><td><b>Warehouse</b></td><td>${order.warehouse}</td></tr>
          <tr><td><b>Warehouse Address</b></td><td>${order.warehouseAddress}</td></tr>

          <tr><td><b>Transporter</b></td><td>${order.transporter}</td></tr>
          <tr><td><b>CHA</b></td><td>${order.cha}</td></tr>
          <tr><td><b>CHA Contact</b></td><td>${order.chaContactPerson}</td></tr>

          <tr><td><b>Surveyor</b></td><td>${order.surveyor}</td></tr>
          <tr><td><b>Surveyor Contact</b></td><td>${order.surveyorContactPerson}</td></tr>

          <tr><td><b>Labour Contractor</b></td><td>${order.labourContractorName}</td></tr>
          <tr><td><b>Weigh Bridge</b></td><td>${order.weighBridgeName}</td></tr>


        </table>

        <hr/>

        <p style="color:red;font-weight:bold">
          This Delivery Order will be permanently deleted!
        </p>

      </div>
    `,
    });

    if (!result.isConfirmed) return;

    try {
      await axios.delete(
        `https://irc.zentelex.com/api/delete/delivery-orders/${order.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Deleted Successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchOrders();
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: "Something went wrong",
      });
    }
  };

  const filteredOrders = orders.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.doNo?.toLowerCase().includes(text) ||
      item.clientName?.toLowerCase().includes(text) ||
      item.commodity?.toLowerCase().includes(text) ||
      item.warehouse?.toLowerCase().includes(text) ||
      item.status?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <h4 className="fw-bold mb-4">Delete Delivery Orders</h4>

      <div className="mb-3">
        <input
          type="text"
          className="form-control border-primary"
          placeholder="🔍 Search DO No / Client / Commodity / Warehouse / Status..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>DO No</th>
              <th>Client</th>
              <th>Commodity</th>
              <th>Warehouse</th>
              <th>Status</th>
              <th width="120">Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.doNo}</td>
                  <td>{item.clientName}</td>
                  <td>{item.commodity}</td>
                  <td>{item.warehouse}</td>
                  <td>
                    <span
                      className={`badge ${
                        item.status === "APPROVED"
                          ? "bg-success"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(item)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No Delivery Orders Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
